import { render, staticRenderFns } from "./ascending_triangle.vue?vue&type=template&id=470bd4cb"
import script from "./ascending_triangle.vue?vue&type=script&lang=js"
export * from "./ascending_triangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports